import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '.';

interface UIState {
    modal: string;
    flaggedMessage: {
        content: string;
        message: string;
        categories: string;
    } | null;
}

const initialState: UIState = {
    modal: '',
    flaggedMessage: null,
};

export const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        openLoginModal(state) {
            state.modal = 'login';
        },
        openSignupModal(state) {
            state.modal = 'signup';
        },
        closeModals(state) {
            state.modal = '';
        },
        setFlaggedMessage(state, action: PayloadAction<{ content: string; message: string; categories: string; }>) {
            state.flaggedMessage = action.payload;
        },
        clearFlaggedMessage(state) {
            state.flaggedMessage = null;
        },
    },
})

export const { openLoginModal, openSignupModal, closeModals, setFlaggedMessage, clearFlaggedMessage } = uiSlice.actions;

export const selectModal = (state: RootState) => state.ui.modal;
export const selectFlaggedMessage = (state: RootState) => state.ui.flaggedMessage;

export default uiSlice.reducer;